import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { HomeComponent, IHomeComponentProps } from '../../components/Home';
import { ESpecialTabs } from '../../constants/specialTabs';
import { selectSpecialTabActive } from '../../hooks/selectors/specialTabs';

const mapStateToProps = (state: IApplicationState): IHomeComponentProps => {
  const {
    mainpage,
    page: { section },
  } = state;

  return {
    isMortgageTabActive: selectSpecialTabActive(state) === ESpecialTabs.Mortgage,
    isFetching: mainpage.isFetching || false,
    top3: mainpage.top3,
    popularJks: mainpage.popularJks,
    section,
  };
};

export const Home = connect<IHomeComponentProps, {}>(mapStateToProps)(HomeComponent);
